import { SubmenuOverlay, useLayoutContext } from '@/container/context/layout/layout-context';
import { ScrollableDiv } from '@components/scrollable-div';
import { useScreenSize } from '@shared/hooks/use-screen';
import clsx from 'clsx';
import SubMenuSidebar from '../submenu-sidebar/submenu-sidebar.view';
import { useOnClickOutside } from '@shared/hooks/use-on-click-outside';
import { useRef } from 'react';

export function SubmenuOverlayPage() {
  const { isSubmenuOverlay, setIsSubmenuOverlay, sidebarCollapsed } = useLayoutContext();
  const { isMobile } = useScreenSize();
  const overlayRef = useRef(null);
  //eslint-disable-next-line
  useOnClickOutside(overlayRef, (e: any) => {
    const isViewAllDiv = e?.srcElement?.id === 'view-all';
    const isViewAllText = e?.srcElement?.parentElement?.id === 'view-all';

    // because close handled in btn itself
    if (isViewAllDiv || isViewAllText) return;

    setIsSubmenuOverlay(null);
  });

  return (
    <ScrollableDiv
      className={clsx(
        'absolute top-0 z-100 bg-surface overflow-x-hidden shadow-lg shadow-primary-200',
        'transition-all duration-300 z-50',
        isSubmenuOverlay ? `w-[290px] opacity-100` : 'w-0 opacity-0',
        sidebarCollapsed ? 'left-[80px]' : isMobile ? '' : `left-[260px]`
      )}
    >
      {isSubmenuOverlay ? (
        <div ref={overlayRef}>
          <SubMenuSidebar
            openSidebarMobileDrawer={() => {}}
            isMobile={false}
            fullWidth={false}
            rootPathname={isSubmenuOverlay as Exclude<SubmenuOverlay, null>}
            channelName="conversations"
          />
        </div>
      ) : null}
    </ScrollableDiv>
  );
}
